<template>
  <v-container fluid>
    <v-row ref="filtersContainer" class="mb-1">
      <v-col cols="6" class="d-flex align-center">
        <span class="text-h5">Список сырья</span>
        <v-dialog v-if="userService.can('raw_material_add_button')" v-model="formDialog" width="500" persistent>
          <template #activator="{on, attrs}">
            <v-btn class="ml-3" style="vertical-align: middle;" rounded color="primary"
                   v-bind="attrs" v-on="on" small
            >
              <v-icon left>mdi-plus</v-icon> Добавить
            </v-btn>
          </template>
          <material-form v-if="formDialog"
                          @material:form:saved="closeForm"
                          @material:form:cancel="closeForm"
          ></material-form>
        </v-dialog>
      </v-col>
      <v-col offset="3" cols="3">
        <v-text-field v-model="filter.name" :disabled="!!fetching"
                      label="Поиск" prepend-inner-icon="mdi-magnify"
                      ref="name_filter"
                      clearable hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      :headers="nonSortableHeaders"
      :items="materials" :items-per-page="filter.limit"
      :loading="!!fetching"
      :height="dataTableHeight" disable-items-per-page hide-default-footer fixed-header
      no-data-text="Нет данных" loading-text="Данные загружаются"
    >
      <template #item="{item, index}">
        <tr>
          <td class="text-center">{{filter.limit * (filter.page - 1) + index + 1}}</td>
          <td>{{item.id}}</td>
          <td>{{item.name}}</td>
          <td>{{(getMeasurement(item.measurement) || {}).name}}</td>
          <td>{{item.buy_price|money}}</td>
          <td>{{item.buy_price_usd|money('usd')}}</td>
          <td>{{item.is_active ? 'активный' : 'неактивный'}}</td>
          <td class="text-right">
            <v-btn class="ml-2" text small depressed color="success" @click="showDetails(item)">
              <v-icon left small>mdi-eye</v-icon>
              Показать
            </v-btn>
            <v-btn class="ml-2" icon small depressed color="primary" dark @click="showForm(item)">
              <v-icon small>mdi-pen</v-icon>
            </v-btn>
            <v-btn class="ml-2" icon small depressed color="error" @click="askRemove(item)"
                   :loading="deleting[item.id]"
            >
              <v-icon left small>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <pagination ref="paginationContainer" :limit.sync="limit" :page.sync="page" :total-pages="totalPages"></pagination>

    <v-dialog v-model="detailDialog" width="60vw">
      <material-details @dialog:close="closeDetails"></material-details>
    </v-dialog>
  </v-container>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapState, mapActions, mapMutations} = createNamespacedHelpers('Material')
  const {mapGetters} = createNamespacedHelpers('Measurement')

  import MaterialDetails from '@/modules/material/details'
  import MaterialForm from '@/modules/material/form'

  import {hasFilter, hasDialog} from '@/mixins'

  export default {
    name: 'material-list',

    mixins: [hasFilter, hasDialog],

    refocusable: {
      name: 'name_filter',
    },

    customFilters: {
      name: '',
    },

    created() {
      this.fetch(this.compiledFilters)
    },

    computed: {
      ...mapState([
        'fetching',
        'data',
        'deleting',
      ]),

      ...mapGetters(['getMeasurement']),

      headers() {
        return [
          {text: '#', align: 'center', width: '100'},
          {text: 'Код'},
          {text: 'Наименование', value: 'name'},
          {text: 'Ед измерения'},
          {text: 'Цена', value: 'buy_price'},
          {text: 'Цена в $', value: 'buy_price'},
          {text: 'Статус'},
          {text: 'Действия', align: 'right', sortable: false},
        ]
      },

      materials() {
        return this.data?.results || []
      },
    },

    methods: {
      ...mapActions(['fetch', 'show', 'remove']),
      ...mapMutations(['setModel']),

      showForm(item) {
        this.formDialog = true
        this.setModel(item)
      },
    },

    mounted() {
      this.$eventBus.$emit('setTitle', 'Список сырья')
      this.$store.dispatch('Measurement/fetch')
    },

    components: {
      MaterialForm,
      MaterialDetails,
    }
  }
</script>
